<script>
import axios from "axios";
import config from "@/config.json";
import {host, webHost, post} from "@/assets/js/utils";

/**
 * Navbar component
 */
export default {
  data() {
    return {
      apiHost: host(),
      webHost: webHost(),
      isCondensed: false,
      isLogin: false,
      user: {
        email: "",
        name: "",
        avatar: ""
      }
    };
  },
  props: {
    isWhiteNavbar: {
      type: Boolean,
    },
    navLight: {
      type: Boolean,
    },
    isIcons: {
      type: Boolean,
    },
  },

  mounted() {
    this.userInfo();

    window.onscroll = function () {
      onwindowScroll();
    };


    function onwindowScroll() {
      if (
        document.body.scrollTop > 50 ||
        document.documentElement.scrollTop > 50
      ) {
        document.getElementById("topnav").classList.add("nav-sticky");
      } else {
        document.getElementById("topnav").classList.remove("nav-sticky");
      }

      if (
        document.body.scrollTop > 100 ||
        document.documentElement.scrollTop > 100
      ) {
        document.getElementById("back-to-top").style.display = "inline";
      } else {
        document.getElementById("back-to-top").style.display = "none";
      }
    }

    var links = document.getElementsByClassName("side-nav-link-ref");
    var matchingMenuItem = null;
    for (var i = 0; i < links.length; i++) {
      if (window.location.pathname === links[i].pathname) {
        matchingMenuItem = links[i];
        break;
      }
    }

    if (matchingMenuItem) {
      matchingMenuItem.classList.add("active");
      var parent = matchingMenuItem.parentElement;

      /**
       * TODO: This is hard coded way of expading/activating parent menu dropdown and working till level 3.
       * We should come up with non hard coded approach
       */
      if (parent) {
        parent.classList.add("active");
        const parent2 = parent.parentElement;
        if (parent2) {
          parent2.classList.add("active");
          const parent3 = parent2.parentElement;
          if (parent3) {
            parent3.classList.add("active");
            const parent4 = parent3.parentElement;
            if (parent4) {
              const parent5 = parent4.parentElement;
              parent5.classList.add("active");
            }
          }
        }
      }
    }
  },
  computed: {
    // 语言完全由 URL 决定，用 computed 保证前进/后退时也同步更新
    lang() {
      return /^\/en(\/|$)/.test(this.$route.path) ? 'en' : 'zh';
    }
  },

  methods: {
    async userInfo() {
      try {
        const data = await post(`${config.api.userinfo}`, {});
        if (data && data.errno === 0) {
          this.isLogin = true;
          this.user = data;
        }
      } catch (e) {
        console.log(e.toString());
      }

    },

    async logout() {
      try {
        const data = await post(`${config.api.logout}`, {redirect: this.webHost});
        if (data && data.errno === 0) {
          localStorage.removeItem("access_token");
          localStorage.removeItem("access_key");
          await this.$router.push('/');
        } else {
          location.href = '/';
        }
      } catch (e) {}
    },
    /**
     * Toggle menu
     */
    toggleMenu() {
      this.isCondensed = !this.isCondensed;
      if (this.isCondensed) {
        document.getElementById("navigation").style.display = "block";
      } else document.getElementById("navigation").style.display = "none";
    },

    /**
     * 切换语言 = 跳到对应语言的 URL。
     * 之前是写 cookie + 整页刷新，那样中英文共用同一个 URL，英文内容无法被单独收录。
     */
    toggleLanguage(lang) {
      if (lang === this.lang) return;
      // 去掉可能存在的 /en 前缀，得到中文基准路径
      const base = this.$route.path.replace(/^\/en(?=\/|$)/, "") || "/";
      const target = lang === "en" ? (base === "/" ? "/en" : "/en" + base) : base;
      this.$cookies.set("mirror-lang", lang);
      this.$router.push(target);
    },

    /**
     * Menu clicked show the submenu
     */
    onMenuClick(event) {
      event.preventDefault();
      const nextEl = event.target.nextSibling.nextSibling;

      if (nextEl && !nextEl.classList.contains("open")) {
        const parentEl = event.target.parentNode;
        if (parentEl) {
          parentEl.classList.remove("open");
        }
        nextEl.classList.add("open");
      } else if (nextEl) {
        nextEl.classList.remove("open");
      }
      return false;
    },
  },
};
</script>

<template>
  <div>
    <!-- Navbar STart -->
    <header
      id="topnav"
      class="defaultscroll sticky"
      :class="{ 'bg-white': isWhiteNavbar === true }"
    >
      <div class="container">
        <!-- Logo container-->
        <div>
          <router-link class="logo" to="/">
            <!--
            <img loading="lazy" v-if="navLight" src="/images/logo-mirror-light.png" height="24" alt="Design Mirror" />
            -->
            <img loading="lazy" src="/images/logo-mirror.png" height="24" alt="Design Mirror" />
          </router-link>
        </div>
        <!-- End Logo container-->
        <div class="menu-extras">
          <div class="menu-item">
            <!-- Mobile menu toggle-->
            <a
              class="navbar-toggle"
              @click="toggleMenu()"
              :class="{ open: isCondensed === true }"
            >
              <div class="lines">
                <span></span>
                <span></span>
                <span></span>
              </div>
            </a>
            <!-- End mobile menu toggle-->
          </div>
        </div>

        <div id="navigation">
          <!-- Navigation Menu-->
          <ul
            class="navigation-menu"
            :class="{ 'nav-light': navLight === true }"
          >
            <li>
              <router-link to="/" class="side-nav-link-ref">{{ $t('navbar.home')}}</router-link>
            </li>
            <li class="has-submenu">
              <a href="javascript:void(0)" @click="onMenuClick">{{$t('navbar.install')}}
                <span class="badge badge-pill badge-danger ml-1">4.0</span>
              </a>
              <span class="menu-arrow"></span>
              <ul class="submenu megamenu">
                <li>
                  <ul>
                    <li>
                      <router-link to="/photoshop" class="side-nav-link-ref">
                        <img loading="lazy" width="20" alt="photoshop" src="/images/photoshop-icon.png"/>
                        <span class="ml-2">Photoshop</span>
                      </router-link>
                    </li>
                    <li>
                      <router-link to="/xd" class="side-nav-link-ref">
                        <img loading="lazy" width="20" alt="xd" src="/images/xd-icon.png"/>
                        <span class="ml-2">Adobe XD</span>
                      </router-link >
                    </li>
                    <li>
                      <router-link to="/illustrator" class="side-nav-link-ref">
                        <img loading="lazy" width="20" alt="illustrator" src="/images/illustrator-icon.png"/>
                        <span class="ml-2">Illustrator</span>
                      </router-link >
                    </li>
                    <li>
                      <router-link to="/sketch" class="side-nav-link-ref">
                        <img loading="lazy" width="20" alt="sketch" src="/images/sketch-icon.png"/>
                        <span class="ml-2">Sketch</span>
                      </router-link >
                    </li>
                    <li>
                      <router-link to="/figma" class="side-nav-link-ref">
                        <img loading="lazy" width="20" alt="figma" src="/images/figma-icon.png"/>
                        <span class="ml-2">Figma</span>
                      </router-link >
                    </li>
                      <li v-if="lang === 'zh'">
                          <router-link to="/mastergo" class="side-nav-link-ref">
                              <img loading="lazy" width="20" alt="mastergo" src="/images/mastergo-icon.png"/>
                              <span class="ml-2">Mastergo</span>
                          </router-link >
                      </li>
                      <li v-if="lang === 'zh'">
                          <router-link to="/jsdesign" class="side-nav-link-ref">
                              <img loading="lazy" width="20" alt="jsdesign" src="/images/jsdesign-icon.png"/>
                              <span class="ml-2">即时设计</span>
                          </router-link >
                      </li>

                    <li>
                      <router-link to="/mobile" class="side-nav-link-ref">
                        <img loading="lazy" width="20" alt="app" src="/images/phone-icon.png?11"/>
                        <span class="ml-2">{{$t('navbar.mobile')}}</span>
                      </router-link >
                    </li>
                    <li>
                      <router-link to="/v4" class="side-nav-link-ref">
                        <i class="uil uil-rocket text-primary" style="font-size:18px"></i>
                        <span class="ml-2">{{$t('navbar.v4overview')}}</span>
                      </router-link >
                    </li>
                  </ul>
                </li>

              </ul>
            </li>
            <li class="has-submenu">
              <a href="javascript:void(0)">{{$t('navbar.buy')}}</a>
              <span class="menu-arrow"></span>
              <ul class="submenu megamenu">
                <li>
                  <ul>
                    <li>
                      <router-link to="/buy" class="side-nav-link-ref">
                        <i class="uil uil-user"></i>
                        <span class="ml-2">{{$t('navbar.individual')}}</span>
                      </router-link>
                    </li>
                    <li>
                      <router-link to="/team" class="side-nav-link-ref">
                        <i class="uil uil-users-alt"></i>
                        <span class="ml-2">{{$t('navbar.team')}}</span>
                      </router-link >
                    </li>
                  </ul>
                </li>

              </ul>
            </li>
            <li> <router-link to="/help" class="side-nav-link-ref">{{ $t('navbar.help')}}</router-link> </li>
            <!--
            <li v-if="!isLogin"> <router-link to="/auth-login" class="side-nav-link-ref">
              {{ $t('navbar.login')}}
            </router-link>
            </li>
            <li v-if="!isLogin"> <router-link to="/auth-signup" class="side-nav-link-ref">
              <img loading="lazy" width="20" alt="register" src="/images/register-icon.png"/>
              <span class="ml-2">{{$t('navbar.register')}}</span>
            </router-link>
            </li>
            -->
            <li class="has-submenu" v-if="!isLogin">
              <router-link to="/auth-login">{{$t('navbar.login')}} </router-link>
              <span class="menu-arrow"></span>
              <ul class="submenu megamenu">
                <li>
                  <ul>
                    <li>
                      <router-link to="/auth-signup" class="side-nav-link-ref">
                        <img loading="lazy" width="20" alt="register" src="/images/register-icon.png"/>
                        <span class="ml-2">{{$t('navbar.register')}}</span>
                      </router-link>
                    </li>
                    <li>
                      <router-link to="/auth-re-password" class="side-nav-link-ref">
                        <img loading="lazy" width="18" alt="register" src="/images/forgot-pass-icon.png"/>
                        <span class="ml-2">{{$t('navbar.forgot_pass')}}</span>
                      </router-link >
                    </li>
                  </ul>
                </li>

              </ul>
            </li>
            <li class="has-submenu" v-if="isLogin">
              <router-link to="/profile" class="side-nav-link-ref">
                <img loading="lazy" :src="user.avatar"  alt="" width="20"/>
                {{ user.name }}
              </router-link>
              <span class="menu-arrow"></span>
              <ul class="submenu megamenu">
                <li>
                  <ul>
                    <li>
                      <a href="#" @click.prevent="logout" class="side-nav-link-ref">
                        <i class="uil uil-signout"></i>
                        <span class="ml-2">{{$t('navbar.logout')}}</span>
                      </a>
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
            <li class="has-submenu">
              <a href="javascript:void(0)">
                <img loading="lazy" :src="'/images/flag-' + lang + '.svg'" alt="flag" width="20">
              </a>
              <ul class="submenu megamenu">
                <li>
                  <ul>
                    <li>
                      <a href="#" @click.prevent="toggleLanguage('zh')" class="side-nav-link-ref">
                        <img loading="lazy" src="/images/flag-zh.svg" alt="flag" width="20">
                        <span class="ml-2">简体中文</span>
                      </a>
                      <a href="#" @click.prevent="toggleLanguage('en')" class="side-nav-link-ref">
                        <img loading="lazy" src="/images/flag-en.svg" alt="flag" width="20">
                        <span class="ml-2">English</span>
                      </a>
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
          </ul>
          <!--end navigation menu-->
          <!--end login button-->
        </div>
        <!--end navigation-->
      </div>
      <!--end container-->
    </header>
    <!--end header-->
    <!-- Navbar End -->
  </div>
</template>
